import React from "react"
import { NavLink } from 'react-router-dom'
import { Image, Label, Menu } from "semantic-ui-react"
import { useSocket, ReadyState } from "../hooks";
import { useAuth } from "../providers";

export const Header = () => {
    const { users, state } = useSocket();
    const { authenticated, user, login, logout } = useAuth();

    const handleLogin = async () => {
        await login();
    };
    const handleLogout = async () => {
        await logout();
    };

    return (
        <Menu inverted stackable fluid style={{ padding: '0px' }}>
            <Menu.Item as={NavLink} to='/home' >
                <Image src='/favicon-32x32.png' avatar spaced='right' />
                Home
            </Menu.Item>
            {authenticated ? (
                <Menu.Item
                    name='dashboard'
                    as={NavLink}
                    to='/dashboard'
                />
            ) : ''}
            <Menu.Item
                name='commands'
                as={NavLink}
                to='/help'
            />
            <Menu.Item
                name='Support'
                as={NavLink}
                to='/support'
            />
            <Menu.Item as={NavLink} to='/live'>
                Currently Live
                <Label color='grey' circular floating>
                    {state !== ReadyState.OPEN ? '0' : users.length}
                </Label>
            </Menu.Item>
            <Menu.Item
                name='Announcements'
                as={NavLink}
                to='/announcements'
            />
            {authenticated ? (
                <Menu.Menu position='right'>
                    <Menu.Item as={NavLink} to='/dashboard'>
                        <Image src={user['avatar']} avatar spaced='right' />
                        {user['display']}
                    </Menu.Item>
                    <Menu.Item
                        name='Logout'
                        as='a'
                        onClick={handleLogout}
                    />
                </Menu.Menu>
            ) : (
                <Menu.Menu position='right'>
                    <Menu.Item
                        name='Login'
                        onClick={handleLogin}
                    />
                </Menu.Menu>
            )}
        </Menu>
    )
}


